import { isNil } from "lodash";

import { useDropdownSourceContext } from "@ryde/redux";
import { IProductionChain, NO_VALUE_DISPLAY } from "@ryde/shared";

import { CsvCellTransformerFn, ICsvColumnTransformer } from "./models";

export const useCsvProductionChainCellTransformer = (): {
  getProductionChainValue: CsvCellTransformerFn;
} => {
  const { getDropdownLabel } = useDropdownSourceContext();

  const getProductionChainValue = async ({
    value,
  }: ICsvColumnTransformer): Promise<string> => {
    const productionChain = value as IProductionChain | undefined;
    const produceButtonId = productionChain?.produceButtonId;

    if (isNil(produceButtonId)) {
      return NO_VALUE_DISPLAY;
    }

    return getDropdownLabel("produceButton", produceButtonId);
  };

  return { getProductionChainValue };
};
